module.exports = __webpack_public_path__ + "public/img/ico-tabbar-inactive-system.ec8ad04e.svg";